import { useQuery } from 'react-query';
import { API_GET_FAQ, API_GATEWAY } from '../../helpers/api';
import { maestroApiCall } from '../..';
export var useGetFAQ = function (application, currentLanguage) {
    var endpoint = "".concat(API_GET_FAQ, "?application=").concat(application, "&language=").concat(currentLanguage !== null && currentLanguage !== void 0 ? currentLanguage : '', "&status=published&includeCommon=true&$limit=1000");
    return useQuery(['faq', application, currentLanguage], function () { return (maestroApiCall({ method: 'GET', endpoint: endpoint, baseURL: API_GATEWAY })); }, {
        enabled: false,
        staleTime: Infinity,
    });
};
//# sourceMappingURL=useGetFAQ.js.map